//Styling
import { keywords } from "../../../variables";
import { SelectedLanguage } from "../../Global/stateTypes";
import { ReferencesContainer } from "./References.style";
//Images
import { RefImages } from "./ReferencesImages";
import { RefObject, SetStateAction, useEffect, useState } from "react";

interface referencesProps {
  referencesRef: RefObject<HTMLDivElement>;
  selectedLanguage : SelectedLanguage;
}

export const References = ({ referencesRef, selectedLanguage }: referencesProps) => {
  return (
    <ReferencesContainer ref={referencesRef}>
      <div className="inner-container">
        <div className="title-container">
          <h1>References</h1>
        </div>
        <div className="bottom-container">
          <div className="images-container">
            {RefImages.map((key,index) => (
              <img src={key} alt={keywords[selectedLanguage][index]} className="refImages" />
            ))}
          </div>
        </div>
      </div>
    </ReferencesContainer>
  );
};
